function initSection() {
    if (document.querySelector('.press-section-wrapper')) {
      const blocks = document.querySelectorAll('.logo-text-block');
      const blockTexts = document.querySelectorAll('.block-text');
  
      function activateBlock(block) {
        blocks.forEach(b => b.classList.remove('active'));
        blockTexts.forEach(b => b.style.display = 'none');
        block.classList.add('active');
        const activeBlockText = document.querySelector(`.block-text[data-block-id="${block.dataset.blockId}"]`);
        if (activeBlockText) {
          activeBlockText.style.display = 'block';
        }
      }
  
      // Set the first block as active by default
      if (blocks.length > 0) {
        activateBlock(blocks[0]);
      }
  
      blocks.forEach(block => {
        // Add event listeners for both mouseenter and click events
        block.addEventListener('mouseenter', function () {
          activateBlock(block);
        });
        block.addEventListener('click', function () {
          activateBlock(block);
        });
      });
  
      // Theme editor functionality
      if (Shopify.designMode) {
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-block-id') {
              const blockId = mutation.target.getAttribute('data-block-id');
              blocks.forEach(b => b.classList.toggle('active', b.getAttribute('data-block-id') === blockId));
            }
          });
        });
  
        blocks.forEach(block => observer.observe(block, { attributes: true }));
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', initSection)
  document.addEventListener('shopify:section:load', initSection)
  document.addEventListener('shopify:section:unload', initSection)